import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Loading } from '@/kit';

/**
 * Bajo demanda, como Promociones. El import va al ARCHIVO y no al barrel `@/domains/credit`, que
 * arrastraría las demás pantallas al mismo chunk y anularía el split.
 */
const InstallmentsPage = lazy(() =>
    import('@/domains/credit/installments/InstallmentsPage').then((m) => ({
        default: m.InstallmentsPage,
    })),
);

// El router coacciona un id numérico a number: se acepta y se normaliza a texto.
const creditParam = z.union([z.string(), z.number()]).transform(String).optional().catch(undefined);

const searchSchema = z.object({ credit: creditParam, credito: creditParam });

export interface InstallmentsSearch {
    credit?: string;
}

/**
 * Deep link `?credit=<id>` o su alias `?credito=<id>`: abre la primera cuota vencida de ese
 * crédito. Con los dos gana `credit`; lo inválido se ignora.
 */
export function parseInstallmentsSearch(search: Record<string, unknown>): InstallmentsSearch {
    const parsed = searchSchema.safeParse(search);
    if (!parsed.success) return { credit: undefined };
    return { credit: parsed.data.credit ?? parsed.data.credito };
}

// Ruta estática: gana sobre la dinámica hermana `$section`, que sigue cubriendo el resto.
export const Route = createFileRoute('/_backoffice/credit/installments')({
    validateSearch: parseInstallmentsSearch,
    component: CreditInstallments,
});

function CreditInstallments() {
    const { credit } = Route.useSearch();
    return (
        <Suspense fallback={<Loading fullScreen text="Cargando cobranza…" />}>
            <InstallmentsPage credit={credit} />
        </Suspense>
    );
}
